"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackToTopBtn = void 0;
const react_1 = __importStar(require("react"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const window_or_global_1 = __importDefault(require("window-or-global"));
const ArrowIconSvg_atom_1 = require("./ArrowIconSvg.atom");
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const Button = styled_components_1.default.button `
    appearance: none;
    background: none;
    border-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(p) => p.theme.palette.text.primary};

    transition: color 0.3s ${(p) => p.theme.easing};

    &:hover {
        color: ${(p) => p.theme.palette.accent.text};
        cursor: pointer;
        .arrow-wrap {
            ${(p) => p.theme.breakpoints.up('md')} {
                transform: translate3d(0, 0, 0) translateY(-2px);
            }
            border-color: ${(p) => p.theme.palette.accent.text};
            svg path {
                fill: ${(p) => p.theme.palette.accent.text};
            }
        }
    }

    .arrow-wrap {
        margin-right: 8px;
        transition: color 0.3s ${(p) => p.theme.easing}, border-color 0.3s ${(p) => p.theme.easing}, transform 0.3s ${(p) => p.theme.easing};

        ${(p) => p.theme.breakpoints.down('sm')} {
            border: 1px solid ${(p) => p.theme.palette.text.primary};
            border-radius: 2px;
            margin: 0;
            padding: 4px 6px;
            svg {
                height: 20px;
                width: 22px;
                padding-right: 2px;
            }
        }
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        align-items: flex-start;
        .btt-label {
            display: none;
        }
    }

    span {
        font-family: ${(p) => p.theme.fonts.default};
        font-size: 13px;
        line-height: 16px;
        letter-spacing: 2px;
        font-weight: 600;
        text-decoration: none;
        text-transform: uppercase;
    }
`;
const BackToTopBtn = () => {
    const { messages } = (0, shared_1.useMessages)();
    const label = messages.backToTop || 'Back to top';
    const scrollUp = (0, react_1.useCallback)((e) => {
        window_or_global_1.default.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        e.preventDefault();
    }, []);
    const handleKeyUp = (0, react_1.useCallback)((e) => {
        if (e && (e.key === 'Enter' || e.key === 'Space' || e.key === ' ')) {
            scrollUp(e);
        }
    }, [scrollUp]);
    return (react_1.default.createElement(Button, { "aria-label": label, className: "up-button", onClick: scrollUp, onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, onKeyUp: handleKeyUp },
        react_1.default.createElement(ArrowIconSvg_atom_1.ArrowIconSvg, { relative: true }),
        react_1.default.createElement("span", { className: "btt-label" }, label)));
};
exports.BackToTopBtn = BackToTopBtn;
//# sourceMappingURL=BackToTopBtn.atom.js.map